@if (!isLoading) {
  <div class="flex-1-1-0">
    <app-booking-details
      [isAdminView]="true"
      class="padding-bottom-48"
      [booking]="booking"></app-booking-details>
  </div>
  @if (booking.status === 'pending') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onGoBack()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      <button
        type="submit"
        class="inwi-icon-text-button-large-primary"
        (click)="onConfirmPayment()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-check-double"></i>
          </div>
          <div class="button-text">Zahlung genehmigen</div>
        </div>
      </button>
      <button
        type="button"
        class="inwi-icon-text-button-large-red"
        (click)="cancelBooking()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-check-double"></i>
          </div>
          <div class="button-text">Buchung stornieren</div>
        </div>
      </button>
    </div>
  } @else if (isSeminarInFuture() && booking.status !== 'cancelled') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-red"
        (click)="cancelBooking()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-check-double"></i>
          </div>
          <div class="button-text">Buchung stornieren</div>
        </div>
      </button>
    </div>
  }
} @else {
  <div class="loading-wrapper">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
    </mat-progress-spinner>
  </div>
}
